// Invoke strict mode
"use strict";

/**
 * Configuration object to handle settings/options.
 *
 * @object config
 */
var config = {
  video: {
    base: "https://www.youtube.com/",
    id: "IDHm81ELZEE",
    params: ["modestbranding=1", "showinfo=0", "autoplay=1"],
  },
  share: {
    facebook: {
      url: "https://www.facebook.com/sharer.php?u={url}",
    },
    twitter: {
      url: "https://twitter.com/intent/tweet?text={body}&url={url}",
      body: "I am sharing the #RainforestFireChannel to bring attention to the only fire we should be watching this holiday. Stream and donate to support the Amazon Rainforest Conservancy’s efforts to save our Rainforest. www.RainforestFireChannel.com",
    },
  },
};

/**
 * Main object to handle all application logic.
 *
 * @object app
 */
var app = {

  /**
   * Method to handle app initialization.
   *
   * @method app.init
   */
  init: function () {

    // Handle on click of scroll icon to move down to the video section
    var scroll = document.querySelector(".button-scroll");
    scroll.onclick = function (event) {
      event.preventDefault();
      document.querySelector(".section-video").scrollIntoView(false);
    };

    // Handle the social share buttons
    var share = document.querySelectorAll("a[data-network]");
    for (var index = 0; index < share.length; index++) {
      share[index].onclick = app.share;
    }

    // Handle the watch button
    var watch = document.getElementById("watch");
    watch.onclick = app.watch;

    // Handle the close overlay button
    var close = document.querySelector(".gallery-close");
    var video = document.querySelector("video")
    close.onclick = function (event) {
      window.setTimeout(function () {
        // document.querySelector(".gallery-content").innerHTML = "";
      }, 1500);
      video.pause()
    };

    // Handle click of the donate button
    var donate = document.querySelectorAll("a[data-donate]");
    for (var index = 0; index < donate.length; index++) {
      donate[index].onclick = function (event) {
        snaptr("track", "PURCHASE");
      };
    }

  },

  /**
   * Method to handle window load event.
   *
   * @method app.load
   */
  load: function () {

    // Show the content
    document.body.style.visibility = "visible";

  },

  /**
   * Method to handle click on watch now button.
   *
   * @method app.watch
   */
  watch: function (event) {

    var content = document.querySelector(".gallery-content");
    var id = config.video.id;
    var params = config.video.params.join("&");
    var base = config.video.base;
    var frame = base + "embed/" + id + "?" + params;
    var link = base + "watch?v=" + id;
    var video = document.querySelector("video")

    video.play()


    // content.innerHTML = [
    //   '<iframe src="', frame, '">',
    //   '  <a href="', link, '">',
    //   '    View on YouTube',
    //   '  </a>',
    //   '</iframe>',
    // ].join("");

  },

  /**
   * Method to handle click on share items.
   *
   * @method app.share
   */
  share: function (event) {

    // Prevent default functionality
    event.preventDefault();

    // Get the params from the config based on network attribute value
    var params = config.share[this.dataset.network];

    // Get the share url based on network
    var url = config.share[this.dataset.network].url
      .replace("{url}", window.encodeURIComponent(window.location.href))
      .replace("{body}", window.encodeURIComponent(params.body));

    // Open the share page in a new tab/window
    window.open(url, "_blank");

  },

};

// Bind the app initialization to the DOM content loaded event
window.addEventListener("DOMContentLoaded", app.init.bind(app));

// Bind the app loaded method to the window load event
window.addEventListener("load", app.load.bind(app));

// Google Analytics
window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }
gtag("js", new Date());
gtag("config", "UA-154570968-1");
